import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    candidateAttachs: {
      selectIds: [],
      filters: {},
      paginate: {},
      selectId: false
    }
  },
  mutations: {
    SET_CANDIDATEATTACH_SELECT_IDS (store, ids) {
      store.candidateAttachs.selectIds = ids
    },
    REMOVE_CANDIDATEATTACH_SELECT_IDS (store, ids) {
      store.candidateAttachs.selectIds = store.candidateAttachs.selectIds.filter((v) => { return !ids.includes(v) })
    },
    SET_CANDIDATEATTACH_SELECT_ID (store, id) {
      store.candidateAttachs.selectId = id
    },
    SET_CANDIDATEATTACH_FILTERS (store, filters) {
      store.candidateAttachs.filters = filters
    },
    SET_CANDIDATEATTACH_PAGINATE (store, val) {
      store.candidateAttachs.paginate = {
        limit: val.limit,
        page: val.page,
        pages: val.pages,
        total: val.total
      }
    }
  },
  getters: {
    getCandidateAttachs: (store, getters) => {
      return store.candidateAttachs.selectIds.map((id) => {
        return getters['entities/candidateAttachs/find'](id)
      })
    },
    getCandidateAttachsFilters: (store, getters) => {
      return store.candidateAttachs.filters
    },
    getCandidateAttachsPaginate: (store, getters) => {
      return store.candidateAttachs.paginate
    },
    getCandidateAttach: (store, getters) => {
      return getters['entities/candidateAttachs/find'](store.candidateAttachs.selectId) || {}
    }
  },
  actions: {
    /*
    selectCandidateAttachs
    */
    selectCandidateAttachs ({commit, dispatch, getters, state}, filters) {
      return dispatch('getCandidateAttachs', filters)
      .then((response) => {
        commit('SET_CANDIDATEATTACH_FILTERS', filters)
        commit('SET_CANDIDATEATTACH_PAGINATE', response)
        commit('SET_CANDIDATEATTACH_SELECT_IDS', response.docs.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectCandidateAttachs
    */
    refreshSelectCandidateAttachs ({commit, dispatch, getters, state}) {
      return dispatch('selectCandidateAttachs', getters.getCandidateAttachsFilters)
    },
    /*
    selectCandidateAttach
    */
    selectCandidateAttach ({commit, dispatch, getters, state}, id) {
      return dispatch('getCandidateAttachById', id)
      .then((response) => {
        commit('SET_CANDIDATEATTACH_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getCandidateAttachs
    */
    getCandidateAttachs ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/candidate-attachs`, {params: filters})
      .then((response) => {
        return dispatch('entities/candidateAttachs/insert', {
          data: response.data.docs
        })
        .then((result) => {
          return {
            docs: result.candidateAttachs || [],
            limit: response.data.limit,
            page: response.data.page,
            pages: response.data.pages,
            total: response.data.total
          }
        })
      })
    },
    /*
    getCandidateAttachById
    */
    getCandidateAttachById ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/candidate-attachs/${id}`)
      .then((response) => {
        return dispatch('entities/candidateAttachs/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.candidateAttachs[0]
      })
    },
    /*
    createCandidateAttach
    */
    createCandidateAttach ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/candidate-attachs`, data)
      .then((response) => {
        return dispatch('entities/candidateAttachs/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.candidateAttachs[0]
      })
    },
    /*
    updateCandidateAttach
    */
    updateCandidateAttach ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/candidate-attachs/${data._id}`, data)
      .then((response) => {
        return dispatch('entities/candidateAttachs/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.candidateAttachs[0]
      })
    },
    /*
    deleteCandidateAttach
    */
    deleteCandidateAttach ({commit, dispatch, getters, state}, id) {
      return axios
      .delete(`/accounts/${getters.getAccount._id}/candidate-attachs/${id}`)
      .then((response) => {
        commit('REMOVE_CANDIDATEATTACH_SELECT_IDS', [id])
        dispatch('entities/candidateAttachs/delete', id)
        return {}
      })
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/CandidateAttach.js